import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";
import { path } from "../Helpers/Accesos";

export const PrivateRouter = ({
  Autenticado,
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        Autenticado ? (
          <Component {...props} />
        ) : (

          <Redirect to={`/auth/login`} />
        )
      }
    />
  );
};

PrivateRouter.propTypes = {
  Autenticado: PropTypes.bool.isRequired,
  component: PropTypes.func.isRequired,
};
